import Bot from "@/bots/Bot";
import store from "@/store";
import { HumanChatMessage,AIChatMessage } from "langchain/schema";

export default class LangChainBot extends Bot {
  static _brandId = "langChainBot";
  static _className = "LangChainBot";
  static _logoFilename = "";
  static _loginUrl = ""; // URL for the login button on the bots page
  static _model = "";
  static _chatModel = undefined; // ChatModel instance

  constructor() {
    super();
  }

  async checkAvailability() {}


  async _sendPrompt(prompt, onUpdateResponse, callbackParam) {
    let messages = await this.getChatContext();
    // Remove old messages if exceeding the pastRounds limit
    while (messages.length > store.state.openaiApi.pastRounds * 2) {
      messages.shift();
    }
    let chatMessages = [];
    // Convert messages to HumanChatMessage and AIChatMessage
    for (let i = 0; i < messages.length; i++) {
      const message = messages[i];
      if (message.role === "user") {
        chatMessages.push(new HumanChatMessage(message.content));
      } else if (message.role === "response") {
        chatMessages.push(new AIChatMessage(message.content));
      }
    }
    // Add the prompt to the messages
    chatMessages.push(new HumanChatMessage(prompt));
    let res = "";
    const model = this.constructor._chatModel;
    const callbacks = [{
      handleLLMNewToken(token) {
        if(token) {
            res += token;
            onUpdateResponse(callbackParam, { content: res, done: false });
        } else {
            onUpdateResponse(callbackParam, { done: true });
        }
      }
    }]
    model.callbacks = callbacks;
    await model.call(chatMessages);
  }

  async createChatContext() {
    return [];
  }

}